var Event = require('./event.js')

module.exports = Source

function Source(broadcaster) {
    var tuple = Event()

    broadcaster(tuple.broadcast)

    return tuple.listen
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/geval/source.js
// module id = 193
// module chunks = 0